import { mapGetters, mapMutations, mapState } from 'vuex'
import _sortBy from 'lodash/sortBy'
import Markdown from 'markdown-it'

export default {
    data() {
        return {}
    },

    created() {
        this.initProductSlots()
        this.applyInitialSlotRates()
        this.rateModal = $('#rate-modal')
        this.md = new Markdown()
    },

    methods: {

        showProductSlots(product, slotsVisible) {
            // mirar aqui quan deactiven els mobils per saber si s'ha de mostrar l'alert
            let products = this.serializeProducts;
            let possible = true;
            if (products.net.length !== 0){
                products.net.forEach(prod => {
                    if(prod.rate.id === 1514 && product.reference === 'CELL' && slotsVisible === 0){
                        document.querySelector('.noPossibleAlert').classList.remove('disabledText');
                        possible = false
                        return;
                    }
                })
                if (!possible) return;
            }
            if (products.cell.length !== 0){
                products.cell.forEach(prod => {
                    if(product.reference === 'NET' && prod.rate.id === 1542){
                        document.querySelector('.noPossibleAlert').classList.remove('disabledText');
                        possible = false
                        return;
                    }
                })
                if (!possible) return;
            }
            document.querySelector('.noPossibleAlert').classList.add('disabledText');
            if(!this.currentConfig[product.reference]) return

            // hide all step errors (as it is a new product configuration)
            this.showErrors({ step: 'one', value: false })

            // enable/disable slots
            this.updateProductSlotsVisible({productType: product.reference, slotsVisible})

            // set default rate per slot
            Object.entries(this.currentConfig[product.reference].slots).forEach((productSlot, i) => {
                this.updateProductSlotRate({
                    productType: product.reference, // CELL
                    slotKey: productSlot[0], // CELL1
                    rate: (i < slotsVisible) // slot is enabled or disabled
                        ? productSlot[1].rate ?? this.getDefaultProductTypeRate(product.reference) // default rate for enabled slots
                        : null // unset rate for disabled slots
                })
            })

            // disable dependant products if current products has no enabled slots
            if(slotsVisible < 1) this.disableDependendentProductsOf(product)

            // enable dependencies for current product if we enable slots for current product
            if(slotsVisible > 0) this.enableDependenciesForProduct(product)
        },

        enableDependenciesForProduct(product) {
            product.dependencies?.forEach(productRef => {
                let product = this.products.find(p => p.reference === productRef)
                if(this.currentConfig[productRef].visible === 0) this.showProductSlots(product, 1)
            })
        },

        disableDependendentProductsOf(product) {
            this.products.forEach(prod => {
                if(prod.dependencies?.includes(product.reference)) this.showProductSlots(prod, 0)
            })
        },

        shouldShowProductSlot(productType, index) {
            if(!this.currentConfig[productType]) return false
            return index < this.currentConfig[productType].visible
        },

        showProductRate(rate, e) {
            e.preventDefault();
            e.stopPropagation();

            this.rateModal.find('.modal-title').text(rate.name)
            this.rateModal.find('.modal-body').html(this.md.render(rate.description || ''))
            this.rateModal.modal()
        },

        setProductSlotRate(productType, slotIndex, rate) {
            let slotKey = productType+(slotIndex+1)
            this.updateProductSlotRate({productType, slotKey, rate})
            if(rate.id === 1513 && this.currentMap.FIX1 !== 0){
                this.products[2].rates.forEach(element => {
                    if(element.id === 1442){
                        let slotKey = 'FIX1'
                        let productType = 'FIX'
                        let rate = element
                        this.updateProductSlotRate({productType, slotKey, rate})
                    }
                })
            }
            if(rate.id === 1514 && this.currentMap.FIX1 !== 0){
                this.products[2].rates.forEach(element => {
                    if(element.id === 1484){
                        let slotKey = 'FIX1'
                        let productType = 'FIX'
                        let rate = element
                        this.updateProductSlotRate({productType, slotKey, rate})
                    }
                })
            }
            if(rate.id === 1442 && this.currentMap.NET1 !== 0){
                this.products[1].rates.forEach(element => {
                    if(element.id === 1513){
                        let slotKey = 'NET1'
                        let productType = 'NET'
                        let rate = element
                        this.updateProductSlotRate({productType, slotKey, rate})
                    }
                })
            }
            if(rate.id === 1484 && this.currentMap.NET1 !== 0){
                this.products[1].rates.forEach(element => {
                    if(element.id === 1514){
                        let slotKey = 'NET1'
                        let productType = 'NET'
                        let rate = element
                        this.updateProductSlotRate({productType, slotKey, rate})
                    }
                })
            }
        },

        productSlotDiff(slotIndex, rate) {
            if(this.isProductSlotRateSelected(rate.product_type, slotIndex, rate.id)) return 'current'
            return this.getConfigurationsDiff(rate.product_type+(slotIndex+1), rate.id)
        },

        formattedDiff(productType, slotIndex, rate) {
            let price = this.getConfigurationsDiff(productType+(slotIndex+1), rate.id)
            return (price / 100).toFixed(2).toString().replace('.',',')
        },

        setProductSlotConfiguration(productType, slotIndex, config) {
            let slotKey = productType+(slotIndex+1)
            this.updateProductSlotConfiguration({ productType, slotKey, config })
        },

        noProductSlotsToShow(productType) {
            return this.currentConfig[productType].visible === 0
        },

        isProductSlotRateSelected(productType, slotIndex, rateId) {
            let slotKey = productType+(slotIndex+1) // FIX1
            return this.currentConfig[productType].slots[slotKey].rate?.id === rateId
        },

        productHasVisibleSlots(product) {
            return this.productVisibleSlots(product) > 0
        },

        productHasNoVisibleSlots(product) {
            return this.productVisibleSlots(product) < 1
        },

        ordered(items, orderKey = 'index') {
            return _sortBy(items, orderKey)
        },

        productNumber(index, product) {
            if(product.slots_max < 2) return
            if(!product.visible) return
            if(!this.currentConfig[product.reference]) return
            if(this.currentConfig[product.reference].visible < 2) return

            return "#"+(index+1)
        },

        showNoAvailableAlertText(){
            document.querySelector('#notAvailable').classList.remove('disabledText')
        },

        ...mapMutations( 'steps', [
            'showErrors',
        ]),

        ...mapMutations('products', [
            'initProductSlots',
            'applyInitialSlotRates',
            'updateProductSlotRate',
            'updateProductSlotConfiguration',
            'updateProductSlotsVisible',
        ]),
    },

    computed: {

        ...mapState('products', {
            products: state => state.products,
            initialMap: state => state.selection.initialMap,
            currentMap: state => state.selection.currentMap,
            currentConfig: state => state.currentConfig,
            productVisibleSlots: state => (product) => state.currentConfig[product?.reference]?.visible ?? null,
        }),

        ...mapGetters('products', [
            'getDefaultProductTypeRate',
            'getConfigurationsDiff', 'serializeProducts'
        ]),

        canNotSelectBasicNetOption() {
            return this.currentConfig?.CELL?.visible > 0 ?? false
        },
        canNoSelectCellOption() {
            return this.currentConfig?.NET?.slots?.NET1?.rate?.id === 1514;
        },
        isFirstCellOption() {
            return !(this.currentConfig?.CELL?.visible !== 1 && this.currentConfig?.NET?.visible !== 0);

        },

    }
}
